export const SortByComponent = {
  templateUrl: './app/ajs/_shared/components/sort-by/sort-by.component.html',
  bindings: {
    sortdir: '=',
    sortedby: '=',
    sortvalue: '@',
    onsort: '=',
  },
  controller: SortByComponentController,
  transclude: true,
};

function SortByComponentController() {
  this.sort = function () {
    if (this.sortedby === this.sortvalue) {
      this.sortdir = this.sortdir === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedby = this.sortvalue;
      this.sortdir = 'asc';
    }

    this.onsort(this.sortedby, this.sortdir);
  };
}
